export default __webpack_public_path__ + "static/media/bacqueville6.e8bdfdee.jpg";